<template>
    <!--页面-->
    <el-container class="i-body">

      <el-aside class="i-side" width="270px">

        <split-pane :min-percent="10" :default-percent="50" split="horizontal">
          <div slot="paneL" class="i-side-pane" data-20180626>
            <!-- <aside-tab color class="" border :tabs="['Container List']" v-model="currnetTab" left></aside-tab> -->
            <aside-list
              delay
              title="Container List"
              :datas="aside_containers"
              :props="aside_props_container"
              :get-status="getDeviceStatus"
              :get-name="getDeviceName"
              :get-alarm="getAlarmState"
              @click="containerClick">
            </aside-list>
          </div>
          <div slot="paneR" class="i-side-pane" data-20180626>
            <!-- <el-button @click="test">test</el-button> -->
            <!-- <aside-tab color class="" border :tabs="['Device List']" v-model="currnetTab" left></aside-tab> -->
            <aside-list
              title="Device List"
              :datas="aside_devices"
              :props="aside_props_device"
              :get-status="getDeviceStatus"
              :get-name="getContainerName"
              :get-alarm="getAlarmState"
              @click="asideDeviceClick">
            </aside-list>
          </div>
        </split-pane>

        <!--类型列表-->
        <el-row type="flex" class="typeline" v-if="false">
          <el-col :span="4" style="color: rgb(32, 160, 255)" :class="{active: currentStateCode==100}" @click.native="currentStateCode=100">{{$t('aside.type[0]')}}</el-col>
          <el-col :span="4" style="color: rgb(19, 206, 102)" :class="{active: currentStateCode==1}" @click.native="currentStateCode=1">{{$t('aside.type[1]')}}</el-col>
          <el-col :span="4" style="color: rgb(153, 169, 191)" :class="{active: currentStateCode==0}" @click.native="currentStateCode=0">{{$t('aside.type[2]')}}</el-col>
          <el-col :span="4" style="color: rgb(255, 73, 73)" :class="{active: currentStateCode==10}" @click.native="currentStateCode=10">{{$t('aside.type[3]')}}</el-col>
          <el-col :span="4" style="color: rgb(247, 186, 42)" :class="{active: currentStateCode==66}" @click.native="currentStateCode=66">{{$t('aside.type[4]')}}</el-col>
        </el-row>

      </el-aside>

      <el-container class="">
        <el-main class="i-main" data-20180626>
          <split-pane @resize="resize" :min-percent="10" :default-percent="currentItem.DeviceID ? 50 : 100" split="vertical">
            <div slot="paneL" class="i-pane-wrapper">
              <div class="i-pane i-pane-map" ref="imap"></div>
              <div class="i-pane i-pane-alarm elevation-10" :style="alarmPanel">
                <div class="i-pane-alarm-btn" @click="alarmTabShow = !alarmTabShow">
                  <i class="el-icon-arrow-down" v-if="!alarmTabShow"></i>
                  <i class="el-icon-arrow-up" v-if="alarmTabShow"></i>
                </div>
                <alarm :alarms="alarm_datas" :logs="log_datas" @alarm-click="alarmClick"></alarm>
              </div>
            </div>
            <template slot="paneR">
              <div class="i-pane chart">
                <charts
                  :datas="currentItem"
                  :tab="rightTab"
                  :item-historys="currentItemHistory"
                  v-if="currentItem.DeviceID"
                  :tab-lists="rightList"
                  ref="chart"></charts>
              </div>
            </template>
          </split-pane>
        </el-main>
        <!-- <el-footer class="i-footer" height="40px"></el-footer> -->
      </el-container>

      <router-view></router-view>
    </el-container>

</template>

<script>
import {getBattery} from './others'
import {getToken} from '@/common/auth'
import tree from '@/components/tree'
import mapToolConfig from '@/components/map-tool-config'
import { remoteLoad, findFromArray, debounce } from '@/common/utils'
import Charts from './charts'
import {mapMutations,mapGetters} from 'vuex'
//import {GooglePanel, GetWrapper} from './maps/google-map.js'
import AsideList from './aside-list'
import AsideTab from './aside-tab'
import Alarm from './alarm/alarm'
import * as Convert from './convert'
import miment from 'miment'

const ACTIVATED = 1
const CONNECTED = 2
const ATTACHED = 3
import { QueryContainer, QueryDevice, QueryAlarm, QueryContainerLogs, QueryHistory, QueryNewContainerLogs, QueryNewAlarms, QueryContainerHistory } from '@/api/home'
import { resolve } from 'url';
import { Filter, Op } from '@/api/config'
import print from '@/common/print'
import { getMapConfig } from '@/common/cache'
import { setInterval, clearInterval, setTimeout } from 'timers';

export default {
  name: 'home',
  data() {
    return {

      aside_containers: [], // 侧栏集装箱数据
      aside_devices: [], // 侧栏设备数据
      aside_props_container: { name: 'ContainerName', state: 'DeviceSN', id: 'ContainerName' }, //
      aside_props_device: { name: 'DeviceName', state: 'Status', id: 'DeviceName' },

      containers: [],
      tableData: [],

      mapConfigVisible: false,
      mapConfig: {},
      currentStateCode: 100,
      currentSelectKey: ['1', '2', '3'],
      onMapData: [],
      currentItem: {}, // 当前点击的设备信息
      currnetTab: 0,
      currentItemHistory: [],
      rightTab: 0,
      rightList: [],
      right_container_tab: ['Device', 'Container'],
      right_device_tab: ['Device'],

      alarmTabShow: true,
      alarm_datas: [],
      log_datas: [],

      refresh_all_time: 2, // 刷新地图数据时间 单位：秒
      refresh_current_time: 1, // 刷新当前数据时间
      debug: process.env.NODE_ENV !== 'production' && false
    }
  },
  computed: {
    ...mapGetters([
      'userId',
      'clickedObjectId'
    ]),
    alarmPanel() {
      return {
        transform: this.alarmTabShow ? 'translateY(100%)' : 'translateY(0)'
      }
    }
  },
  watch: {
    // currentStateCode() {
    //   this.fetchData()
    // },
    // currentSelectKey() {
    //   this.fetchData()
    // }
    currentItem(newVal, oldVal) {
      if (this.timer_refresh_current) {
        clearInterval(this.timer_refresh_current)
      }
      this.timer_refresh_current = setInterval(() => {
        this.fetchCurrentDeviceLocal()
      }, this.refresh_current_time * 1000)

      if (!oldVal || (newVal.DeviceID != oldVal.DeviceID)) {
        if (newVal.ContainerID && (newVal.Status == 2 || newVal.Status == 3)) {
          this.fetchCurrentItemHistory().then(list => {
            // 刷新右面板
            print.tip('获取历史数据并刷新右面板', true)

            this.$refs.chart && this.$refs.chart.drawAgain()

          }).catch(() => {
            // 刷新右面板
            print.tip('获取历史数据失败并刷新右面板', true)
            this.$refs.chart && this.$refs.chart.drawAgain()
          })
        }

        return
      }

      if (this.timer_refresh_history) {
        clearInterval(this.timer_refresh_history)
      }
      this.timer_refresh_history = setInterval(() => {
        this.fetchCurrentItemHistory().then(list => {
            // 刷新右面板
            //print.tip('获取历史数据并刷新右面板', true)

            this.$refs.chart && this.$refs.chart.drawAgain()

          }).catch(() => {
            // 刷新右面板
            //print.tip('获取历史数据失败并刷新右面板', true)
            this.$refs.chart && this.$refs.chart.drawAgain()
          })
      }, 2 * 1000)

      // if (newVal.DeviceID != oldVal.DeviceID) {
      //   this.fetchCurrentItemHistory().then(() => {
      //     var _cur = this.currentItem
      //     this.currentItem = null
      //     setTimeout(() => {
      //       this.currentItem = _cur
      //     }, 500)
      //   })
      // }

    }
  },
  methods: {
    ...mapMutations({
      setClickedObjectId:'SET_CLICKED_OBJECT_ID'
    }),

    sleep(time) {
      const promise = new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve()
        }, time)
      })
      return promise
    },

    getDeviceStatus(row) {
      if (row.Status) {
        return row.Status
      } else {
        const device = findFromArray(this.aside_devices, k => {
          return k.DeviceID == row.DeviceSN
        })
        if (!device) {
          return 0
        } else {
          return device.Status
        }
      }
    },

    getDeviceName(row) {
      if (row.DeviceName) {
        return row.DeviceName
      } else {
        const device = findFromArray(this.aside_devices, k => {
          return k.DeviceID == row.DeviceSN
        })
        if (!device) {
          return '- -'
        } else if (device.Status == 0 || device.Status == 1) {
          return '- -'
        } else {
          return device.DeviceName
        }
      }
    },

    getContainerName(row) {
      if (Convert.isContainer(row)) {
        return row.ContainerName
      } else {
        return '- -'
      }
    },

    getAlarmState(row) {
      if (row.DeviceID) {
        return Convert.onAlarm(row)
      }
      if (row.DeviceSN) {
        const device = findFromArray(this.aside_devices, k => {
          return k.DeviceID == row.DeviceSN
        })
        if (!device) {
          return false
        } else {
          return Convert.onAlarm(device)
        }
      }
      return false
    },

    // filterContainer(row) {
    //   // 只显示已连接设备

    //   if (!row.DeviceSN) {
    //     // 未连接
    //     return false
    //   } else {
    //     // 连接离线
    //     const device = findFromArray(this.aside_devices, k => {
    //       return k.DeviceID == row.DeviceSN
    //     })
    //     if (!device) {
    //       console.log('查找失败', this.aside_devices)
    //       return true
    //     }
    //     return device.Status == 2 || device.Status == 3
    //   }

    // },

    // filterDevice(row) {
    //   const log = false
    //   // 只显示未连接集装箱设备
    //   if (!row.ContainerID) {
    //     log && console.log('过滤结果', true, row)
    //     return true
    //   }
    //   if (row.Status == 0 || row.Status == 1) {
    //     log && console.log('过滤结果', true, row)
    //     return true
    //   }
    //   log && console.log('过滤结果', false, row)
    //   return false
    //   //return (!row.ContainerID) || (!!row.ContainerID && (row.Status == 0 || row.Status == 1))
    // },

    // 下方报警表格点击事件
    alarmClick(deviceID) {
      // console.log('alarmClick', deviceID)
      // 查找绑定的设备
      const device = findFromArray(this.aside_devices, k => {
        return k.DeviceID == deviceID
      })
      this.deviceClick(device, true)
    },

    // 集装箱点击事件
    containerClick(item) {

      if (!item.DeviceSN) {
        // 未绑定
        print.tip('Not bind.', false, 1000, true)
        return
      }

      // 查找绑定的设备
      const device = findFromArray(this.aside_devices, k => {
        return k.DeviceID == item.DeviceSN
      })

      // console.log('find device', device)

      if (!device) {
        // 未绑定
        print.tip('Not bind.', false, 1000, true)
        return
      }

      if (device.Status != 2 && device.Status != 3) {
        print.tip('Not bind.', false, 1000, true)
        return
      }

      // // 没有上传过位置的设备禁止点击
      // if (!device.Lon || !device.Lat) {
      //   print.tip(`${device.DeviceName} has no location.`)
      //   return false
      // }

      this.deviceClick(device, true)
    },

    asideDeviceClick(item) {
      //console.log(item)
      //console.log('点击项目', item)
      if (item.ContainerID && (item.Status == 2 || item.Status == 3)) {
        print.tip('Please click container list.')
        return
      }

      this.deviceClick(item, true)
    },

    // 设备点击事件
    deviceClick(item, byHand = false, byMap = false) {

      // if (item.ContainerID) {
      //   this.rightTab = 1
      // } else {
      //   this.rightTab = 0
      // }

      // 右边面板Loading, 加载历史数据
      // if (item.DeviceID != this.old_DeviceID) {
      //   this.old_DeviceID = item.DeviceID
      //   // 获取历史数据
      //   this.fetchCurrentItemHistory().then(() => {

      //   }).catch(() => {

      //   })
      // }


      // 设置右面板信息
      if (item.ContainerID && (item.Status == 2 || item.Status ==3)) {
        this.rightList = this.right_container_tab
        this.rightTab = 1
      } else {
        this.rightList = this.right_device_tab
        this.rightTab = 0
      }
      // 更换设备


      // 设置当前设备
      this.currentItem = item

      // 地图居中

      // 打开信息窗体
      this.openMarkerWindow(findFromArray(this.markers, marker => {
        return marker.getTitle() == item.DeviceID
      }), item, byHand, byMap)
    },

    // fetchData() {
    //   this.tableData = this.filterList(this.alldata)
    //   this.containers = this.filterList(this.allcontainers)
    // },

    // filterList(datas) {
    //   return datas.filter(item => {
    //     if (this.currentSelectKey.indexOf('1') != -1) {
    //       if (this.currentStateCode == 100 || item.stateCode.indexOf(this.currentStateCode) != -1) {
    //         return true
    //       } else {
    //         return false
    //       }
    //     } else {
    //       if (this.currentSelectKey.indexOf(item.holdId) != -1 && (item.stateCode.indexOf(this.currentStateCode) != -1 || this.currentStateCode == 100)) {
    //         return true
    //       } else {
    //         return false
    //       }
    //     }
    //   })
    // },
    // checkChange(nodes) {
    //   this.currentSelectKey = nodes.slice()
    // },

    // 手动拖动大小时
    resize() {
      if (!this.chart_resize) {
        function _f() {
          console.log('resize')
          this.$refs.chart && this.$refs.chart.reflow()
        }
        this.chart_resize = debounce(_f, 200)
      }

      this.chart_resize()
    },

    // 获取数据
    fetchContainer() {
      // 刷新 aside_containers
      const promise = new Promise((resolve, reject) => {
        QueryContainer(1, 2000, '', '', [])
          .then(ret => {
            if (ret.data.errCode) {
              print.error('Permission denied(Query Container), Please contact administrator.')
              reject(ret.data.errMsg)
            } else {
              this.aside_containers = ret.data.list.slice()
              resolve()
            }
          })
          .catch(err => {
            console.error(err)
            reject(err)
          })
      })

      return promise
    },

    fetchDevice() {
      const promise = new Promise((resolve, reject) => {
        QueryDevice(1, 2000, '', '', [])
          .then((ret) => {
            if (ret.data.errCode) {
              print.error('Permission denied(Query Device), Please contact administrator.')
              reject(ret.data.errMsg)
            } else {
              this.aside_devices = ret.data.list.slice()
              resolve()
            }

          })
          .catch(err => {
            console.log(err)
            reject(err)
          })
      })
      return promise
    },

    fetchCurrentDeviceLocal() {
      if (this.onUpdateLines) {
        return
      }

      const promise = new Promise((resolve, reject) => {

        const item = findFromArray(this.aside_devices, k => {
          return k.DeviceID == this.currentItem.DeviceID
        })

        if ((this.currentItem.UpdateTime != item.UpdateTime)
          || (this.currentItem.Status != item.Status)) {
          this.currentItem = item
          this.deviceClick(item)
        }

        if (this.old_currentItem && (this.old_currentItem.Status != item.Status)) {
          console.log('updateLines')
          this.updateLines()
          this.deviceClick(item)
        }

        this.old_currentItem = item

        resolve()
      })
      return promise
    },

    fetchCurrentDevice() {
      const promise = new Promise((resolve, reject) => {
        const filters = [ new Filter('DeviceID', this.currentItem.DeviceID, Op.Equals) ]
        // if (!this.fetchCurrentDevice_time) {
        //   this.fetchCurrentDevice_time = miment()
        // } else {
        //   filters.push(new Filter('UpdateTime', this.fetchCurrentDevice_time, Op.GreaterThanOrEqual))
        // }
        QueryDevice(1, 2000, '', '', filters)
          .then((ret) => {
            // print.info(`地图当前选择项目数据已刷新，获得数据${data.list.length}条`, true)
            // data.list.length > 0 && (this.currentItem = data.list[0])
            // resolve()
            if (ret.data.errCode) {
              print.error('Permission denied(Query Device), Please contact administrator.')
              reject(ret.data.errMsg)
            } else {
              if (ret.data.list.length > 0) {
                if (!this.currentItem) {
                  //print.tip('获取成功(变化)' + this.currentItem.Temperature, true)
                  this.currentItem = ret.data.list[0]
                  // 打开信息窗体
                  this.deviceClick(this.currentItem)
                } else if (this.currentItem.UpdateTime != ret.data.list[0].UpdateTime) {
                  //print.tip('获取成功(变化)' + this.currentItem.Temperature, true)
                  this.currentItem = ret.data.list[0]
                  // 打开信息窗体
                  this.deviceClick(this.currentItem)
                } else {
                  //print.tip('获取成功(无变化)' + this.currentItem.Temperature, true)
                }

                if (this.old_currentItem && (this.old_currentItem.Status != ret.data.list[0].Status)) {
                  this.updateLines()
                }

                this.old_currentItem = ret.data.list[0]
              }

              //ret.data.list.length > 0 && (this.currentItem = ret.data.list[0])

              resolve()
            }
          })
          .catch(err => {
            console.log(err)
            reject(err)
          })
      })
      return promise
    },

    fetchAlarm() {
      const promise = new Promise((resolve, reject) => {
        QueryAlarm([])
          .then(({ data }) => {
            this.alarm_datas = data.slice()
            resolve()
          })
          .catch(err => {
            console.error(err)
            reject()
          })
      })
      return promise
    },

    fetchContainerLogs() {
      const promise = new Promise((resolve, reject) => {
        QueryContainerLogs([])
          .then(({data}) => {
            this.log_datas = data.slice()
            resolve()
          })
          .catch(err => {
            console.error(err)
            reject()
          })
      })
      return promise
    },

    fetchCurrentItemHistory() {
      const ContainerID = this.currentItem.ContainerID
      const startTime = miment().sub(1, 'hh').format('YYYY/MM/DD hh:mm:ss')
      const endTime = miment().format('YYYY/MM/DD hh:mm:ss')
      const promise = new Promise((resolve, reject) => {
        QueryContainerHistory(ContainerID, startTime, endTime).then(({data}) => {
          //console.log(data)
          let distinctList = this.distinct(data.list.slice()) // 解决D消失
          //let distinctList = data.list.slice()
          this.currentItemHistory = distinctList.slice()
          resolve(this.currentItemHistory)
        }).catch(err => {
          console.error(err)
          reject()
        })
      })
      return promise
    },

    fetchNewContainerLogs() {
      const promise = new Promise((resolve, reject) => {
        let now
        if (this.fetchNewContainerLogs_old) {
          now = this.fetchNewContainerLogs_old.format('YYYY/MM/DD hh:mm:ss')
          this.fetchNewContainerLogs_old = miment()
        } else {
          this.fetchNewContainerLogs_old = miment()
          now = this.fetchNewContainerLogs_old.format('YYYY/MM/DD hh:mm:ss')
        }
        QueryNewContainerLogs([], now)
          .then(({data}) => {
            data.forEach(item => {
              const log = findFromArray(this.log_datas, i => {
                return i.LID == item.LID
              })
              if (!log) {
                print.tip(`ContainerID：${item.ContainerName}(${item.ContainerID})，${item.LogInfo}`, false, 2000, true)
                this.log_datas.splice(0, 0, item)
                this.log_datas.splice(this.log_datas.length - 1, 1)
              }
            })

            // this.log_datas = data.slice()
            resolve()
          })
          .catch(err => {
            console.error(err)
            reject()
          })
      })
      return promise
    },

    fetchNewAlarms() {
      const promise = new Promise((resolve, reject) => {
        let now
        if (this.fetchNewAlarms_old) {
          now = this.fetchNewAlarms_old.format('YYYY/MM/DD hh:mm:ss')
          this.fetchNewAlarms_old = miment()
        } else {
          this.fetchNewAlarms_old = miment()
          now = this.fetchNewAlarms_old.format('YYYY/MM/DD hh:mm:ss')
        }
        QueryNewAlarms([], now)
          .then(({data}) => {
            data.forEach(item => {
              const log = findFromArray(this.log_datas, i => {
                return i.LID == item.LID
              })
              if (!log) {
                //print.tip(`Alarm：${item.ContainerName ? item.ContainerName : item.DeviceName }(${item.ContainerID ? item.ContainerID : item.SN})，${item.AlarmInfo}`, false, 2000, true)
                this.alarm_datas.splice(0, 0, item)
                this.alarm_datas.splice(this.alarm_datas.length - 1, 1)
              }
            })

            // this.log_datas = data.slice()
            resolve()
          })
          .catch(err => {
            console.error(err)
            reject()
          })
      })
      return promise
    },

    distinct(arr) {
      if (arr.length > 1) {
        for (let j = 0, k = 1; k<arr.length;j++,k++) {
          if (arr[j].RcvTime == arr[k].RcvTime) {
            console.log('去重', arr[j].RcvTime)
            arr.splice(j, 1)
            return this.distinct(arr).slice()
          }
        }
      }
      return arr
    },

    updateLines() {
      this.onUpdateLines = true
      this.fetchCurrentItemHistory().then(list => {


        // 刷新右面板
        print.tip('获取历史数据并刷新右面板', true)

        this.$refs.chart && this.$refs.chart.drawAgain()
        this.onUpdateLines = false
      }).catch(() => {
        // 刷新右面板
        print.tip('获取历史数据失败并刷新右面板', true)
        this.$refs.chart && this.$refs.chart.drawAgain()
        this.onUpdateLines = false
      })
    },

    // 获取数据

    /*
    // 初始化地图google
    initMap() {
      this.$nextTick(() => {
        let map = new google.maps.Map(this.$refs.imap, {
            center: {lat: 33.061798, lng: 110.442263},
            zoom: 4
        })
        this.map = map
        // 获得Wrapper变量
        this.Wrapper = GetWrapper(google)
        this.setAllMarkers()
      })
    },
    */

       initMap() {
          this.$nextTick(() => {
            let AMapUI = this.AMapUI = window.AMapUI
            let AMap = this.AMap = window.AMap
            let mapConfig = {
              resizeEnable: true,
              zoom: 11,
              //center: [116.397428, 39.90923]
            }
            // eslint-disable no-new 
            let map = new AMap.Map(this.$refs.imap, mapConfig)
            // 启用工具条
            AMap.plugin(['AMap.ToolBar'], function () {
              map.addControl(new AMap.ToolBar({
                position: 'lt'
              }))
            })
            // 图层切换控件
            AMapUI.loadUI(['control/BasicControl'], function(BasicControl) {
              map.addControl(new BasicControl.LayerSwitcher({
                position: 'rt'
              }))
            })
            this.map = map
            const googleLayer = new AMap.TileLayer({
                // 图块取图地址
                getTileUrl: 'http://mt{1,2,3,0}.google.cn/vt/lyrs=m@142&hl=en&gl=cn&x=[x]&y=[y]&z=[z]&s=Galil',
                zIndex:100
            })
            googleLayer.setMap(map)
            this.map.setLang('en');
            //alert(googleLayer.getTileUrl);
            
            this.setAllMarkers()
       })
     },   

    // 加载全部集装箱
    setAllMarkers() {
      //const Wrapper = this.Wrapper

      // 设置是否纠偏
      let LatProp = 'Lat'
      let LonProp = 'Lon'
      if (this.mapConfig.useCorrectValue) {
        LatProp = 'Lat_R'
        LonProp = 'Lon_R'
      }

      if (this.markers && this.markers.length) {
        // 再次刷新时
        //console.log('再次刷新')
        let newMarkers = []
        this.aside_devices.forEach(item => {

          // 没有上传过位置的设备不加载
          if (!item.Lon || !item.Lat) {
            return
          }

          let data = item

          // 查找显示面板
          if (this.wrapperWindow && this.panel_open && this.wrapperWindow.getId() == item.DeviceID) {
            this.wrapperWindow.setPosition(new AMap.LatLng(item[LatProp], item[LonProp]))
          }

          // 查找绑定的设备
          let marker = findFromArray(this.markers, marker => {
            return marker.extID == item.DeviceID
          })
          //console.log('找到', marker, this.markers[0])
          const options = item.ContainerID
            ? [this.marker_d_offline, this.marker_d_active, this.marker_orange, this.marker_green]
            : [this.marker_d_offline, this.marker_d_active, this.marker_orange_d, this.marker_green_d]
          const alarmOptions = [this.marker_offline_alarm, this.marker_red_alarm, this.marker_orange_alarm, this.marker_green_alarm]
          const onAlarm = Convert.onAlarm(item)
/*
          if (marker) {
            // 存在移动位置，设置图表颜色，设置点击事件
            let iconPath = onAlarm ? alarmOptions[item.Status] : options[item.Status]

            google.maps.event.clearListeners(marker, 'click')
            marker.setPosition(new google.maps.LatLng(item[LatProp], item[LonProp]))
            marker.setIcon({
              url: iconPath,
              labelOrigin: new google.maps.Point(20, 45)
            })
            marker.addListener('click', () => {
              this.markerClick(marker, data)
            })
          } else {
            // 不存在新增
            // 判断状态

            let iconPath = onAlarm ? alarmOptions[item.Status] : options[item.Status]

            marker = new google.maps.Marker({
              icon: {
                url: iconPath,
                labelOrigin: new google.maps.Point(20, 45)
              },
              position: new google.maps.LatLng(item[LatProp], item[LonProp]),
              title: (Convert.isContainer(item) ? `${item.ContainerName || '--'} ${item.DeviceName || '--'}` : `-- ${item.DeviceName || '--'}`),
              map: this.map,
              extID: item.DeviceID
            })

            marker.addListener('click', () => {
              this.markerClick(marker, data)
            })
          }
*/
          if (marker) {
            // 存在移动位置，设置图表颜色，设置点击事件
            let iconPath = onAlarm ? alarmOptions[item.Status] : options[item.Status]
            AMap.event.clearListeners(marker, 'click')
            //marker.setPosition(new AMap.LatLng(item[LatProp], item[LonProp]))
			marker.setPosition(new AMap.LngLat( item[LonProp],item[LatProp]))
			
            marker.setIcon({
              url: iconPath,
              //labelOrigin: new AMap.Point(20, 45),
			  offset: new AMap.Pixel(20, 45)
            })
            marker.event.addListener('click', () => {
              this.markerClick(marker, data)
            })
          } else {
            // 不存在新增
            // 判断状态

            let iconPath = onAlarm ? alarmOptions[item.Status] : options[item.Status]

            //marker = new google.maps.Marker({
			marker= new AMap.Marker	({
              icon: {
                url: iconPath,
                //labelOrigin: new AMap.Point(20, 45)
				 offset: new AMap.Pixel(20, 45)
              },
              //position: new AMap.LatLng(item[LatProp], item[LonProp]),
			  position: new AMap.LngLat( item[LonProp],item[LatProp]),
              title: (Convert.isContainer(item) ? `${item.ContainerName || '--'} ${item.DeviceName || '--'}` : `-- ${item.DeviceName || '--'}`),
              map: this.map,
              extID: item.DeviceID
            })

            marker.event.addListener('click', () => {
              this.markerClick(marker, data)
            })
          }


          newMarkers.push(marker)
        })
        return
      }

      let markers = this.aside_devices.map((item) => {
		  
        // 没有上传过位置的设备不加载
        if (!item.Lon || !item.Lat) {
          return false
        }

        let data = item

        const options = item.ContainerID
          ? [this.marker_d_offline, this.marker_d_active, this.marker_orange, this.marker_green]
          : [this.marker_d_offline, this.marker_d_active, this.marker_orange_d, this.marker_green_d]
        const alarmOptions = [this.marker_offline_alarm, this.marker_red_alarm, this.marker_orange_alarm, this.marker_green_alarm]
        // 判断状态

        const onAlarm = Convert.onAlarm(item)
        let iconPath = onAlarm ? alarmOptions[item.Status] : options[item.Status]

        let marker = new AMap.Marker({
          icon: {
            url: iconPath,
            //labelOrigin: new AMap.Point(20, 45)
			 labelOrigin: new AMap.Pixel(20, 45)
          },
          position: { lat: parseFloat(item[LatProp]), lng: parseFloat(item[LonProp]) },
          title: (Convert.isContainer(item) ? `${item.ContainerName || '--'} ${item.DeviceName || '--'}` : `-- ${item.DeviceName || '--'}`),
          map: this.map,
          extID: item.DeviceID
        })

        marker.event.addListener('click', () => {
          this.markerClick(marker, data)
        })

		markers.push(marker)
        return marker
      }).filter(item => !!item)

      // this.alldata.forEach(item => {
      //   const wrapper = new Wrapper(this.map, new google.maps.LatLng(item.lat, item.lng), { el: item.name, offsetY: 16 })
      //   markers.push(wrapper)
      // })

      this.markers = markers

      // var markerCluster = new MarkerClusterer(this.map, markers,
      //   {imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m'}
      // );
    },

    // 点击事件
    markerClick(marker, item) {
      //console.log('markerClick')
      this.deviceClick(item, false, true)
    },

    // 显示marker的信息
    // byHand 为true时，居中放大
    openMarkerWindow(marker, item, byHand, byMap) {

      //console.log(item)
      // 没有上传过位置的设备不加载
      if (!item.Lon || !item.Lat) {
        print.tip(`${item.DeviceName} has no location.`)
        if (this.wrapperWindow) {
          this.wrapperWindow.close()
        }
        return false
      }

      // 设置是否纠偏
      let LatProp = 'Lat'
      let LonProp = 'Lon'
      if (this.mapConfig.useCorrectValue) {
        LatProp = 'Lat_R'
        LonProp = 'Lon_R'
      }

      if (byHand) {
 		//this.map.setCenter(new AMap.LngLat( item[LonProp],item[LatProp]))
		this.map.setCenter(new AMap.LngLat( item[LonProp],item[LatProp]))
		
		
        if (this.map.getZoom() < 20) {
          this.map.setZoom(20)
        }
        this.panel_open = true
      }

      if (byMap) {
        this.panel_open = true
      }

      const colors = {
        '3': '#4CAF50',
        '2': '#FF9800',
        '1': '#050505',
        '0': '#607D8B'
      }
      const more = this.userId != '1' ? [] : [
        {title: 'SIM ICCID：', text: item.SIMICCID || '- -'},
        {title: 'SIM IMSI：', text: item.SIMIMEI || '- -'},
        {title: 'Module SN：', text: item.ModuleSN || '- -'},
        {title: 'Module IMEI：', text: item.ModuleIMEI || '- -'},
        {title: 'Cell Info：', text: item.CellInfo || '- -'},
        {title: 'Description：', text: item.StatusDes ? item.StatusDes : '- -'}
      ]
      const panelDatas = [
        {title: 'Device Name：', text: item.DeviceName, highlight: true},
        {title: 'GPS Time', text: item.GPSTime || '- -'},
        {title: 'Longitude：', text: item.Lon},
        {title: 'Latitude：', text: item.Lat}
      ]
      //console.log(item, Convert.onAlarm(item))
      Convert.isContainer(item) && panelDatas.splice(0, 0, {title:'Container Name：', text: item.ContainerName, highlight: true})
      Convert.onAlarm(item) && panelDatas.push({title:'Alarm：', text: Convert.alarmText(item).replace(/alarm/g, '').replace(/Alarm/g, '') })

      if (typeof this.panel_showMore == 'undefined') {
        this.panel_showMore = false
      }
      if (typeof this.panel_open == 'undefined') {
        this.panel_open = true
      }

      const panel = this.$dataPanel.create({
        bgColor: true,
        title: `${Convert.isContainer(item) ? item.ContainerName : item.DeviceName}`,
        attachState: `(${Convert.status(item.Status)})`,
        signal: item.CellSignal,
        battery: item.Battery,
        datas: panelDatas,
        more,
        time: item.RcvTime,
        showMore: this.panel_showMore,
        titleBackground: colors[item.Status],
        close: true,
        //visible: this.panel_open,
        onClose: () => {
          this.wrapperWindow.close()
          this.panel_showMore = false
          this.panel_open = false
        },
        onChange: (val) => {
          this.panel_showMore = val
        }
      })

      const Wrapper = this.Wrapper
      if (this.wrapperWindow) {
        this.wrapperWindow.setId(item.deviceID)
        this.wrapperWindow.setContent(panel)
		//this.wrapperWindow.setPosition(new AMap.LatLng(item[LatProp], item[LonProp]))
		this.wrapperWindow.setPosition(new AMap.LngLat( item[LonProp],item[LatProp]))
 		
        if (this.panel_open) {
          this.wrapperWindow.show()
        } else {
          this.wrapperWindow.hide()
        }
      } else {
        this.wrapperWindow = new Wrapper(this.map, new AMap.LngLat( item[LonProp],item[LatProp]), { el: panel, offsetY: -70 }, item.DeviceID)
      }
    },
    test() {
      this.$refs.chart.drawAgain()
    },
    intro() {
      const nodes = document.querySelectorAll('[data-20180626]')
      console.log(nodes)
      Array.prototype.forEach.call(nodes, (item, index) => {
        console.log(item)
        var div = document.createElement('a')
        console.log('获取到div的高度、宽度、距离屏幕左、距离屏幕上',item.getBoundingClientRect())
      })
    }
  },
  async created() {
    /*
    if (window.google) {
      this.initMap()
      //console.log('google 存在')
    } else {
      // await remoteLoad('https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/markerclusterer.js').catch(err => {
      //   this.$message.error('Network Error')
      // })
      // console.log('created start.')

      await remoteLoad('https://maps.googleapis.com/maps/api/js?key=AIzaSyBAWSlVsxaoSwA56-gcyBijIucrgegOBn8&language=en').catch(err => {
        this.$message.error('Network Error')
      })
      // await remoteLoad(`${location.protocol}//ditu.google.cn/maps/api/js?v=3&key=AIzaSyBAWSlVsxaoSwA56-gcyBijIucrgegOBn8&language=en`).catch(err => {
      //   this.$message.error('Network Error')
      // })
      // console.log('created ok.')
      this.initMap()

      // const promise2 = Promise.all([promise]).then(data => {
      //   console.log('google 加载完成', JSON.stringify(new Date()))
      // })
    }
    */

    if (window.AMap && window.AMapUI) {
      this.initMap()
      // 未载入高德地图API，则先载入API再初始化
    } else {
      await remoteLoad(`http://webapi.amap.com/maps?v=1.4.2&key=43a9650bd8100941d275705f0535c882`)
      await remoteLoad('http://webapi.amap.com/ui/1.0/main.js?v=1.0.11')
      this.initMap()
   }
 

    // this.fetchData()

    if (getToken() == '1') {
      this.currentSelectKey = ['1', '2', '3']
    } else {
      this.currentSelectKey = [getToken()]
    }



    // 加载设备列表
    let promise_load_device = this.fetchDevice()
    let promise_load_container = this.fetchContainer()

    Promise.all([promise_load_device, promise_load_container]).then(() => {
      // this.initMap()
      //console.log('setAllMarkers')
      this.setAllMarkers()
    }).catch(err => {
        console.error('没有权限', err)
      })

    let promise_alarm = this.fetchAlarm()
    let promise_containerLogs = this.fetchContainerLogs()

    // 定时刷新地图数据
    this.timer_refresh_all = setInterval(() => {
      // this.debug && this.$message({
      //   message: '地图数据已刷新',
      //   type: 'info',
      //   duration: 2000,
      //   customClass: 'el-message_custom'
      // })
      let _p1 = this.fetchDevice()
      let _p2 = this.fetchContainer()
      Promise.all([_p1, _p2]).then(() => {
        this.setAllMarkers()
      }).catch(err => {
        console.error('没有权限', err)
      })
    }, this.refresh_all_time * 1000)

    // 定时刷新日志
    // this.fetchNewContainerLogs()
    this.timer_refresh_logs = setInterval(() => {
      //console.log('定时刷新')
      let promise_container_logs = this.fetchNewContainerLogs()
      promise_container_logs.then(() => {}).catch(err => console.error('请求错误', err))
    }, 2000)

    this.timer_refresh_alarms = setInterval(() => {
      //console.log('定时刷新')
      let promise_container_alarms = this.fetchNewAlarms()
      promise_container_alarms.then(() => {}).catch(err => console.error('请求错误', err))
    }, 2000)

    // 设置所有设备位置
    // this.initMap()
    // this.setAllMarker()

    // 获取数据结束

    // 设置地图
    this.mapConfig = getMapConfig()
  },
  mounted() {
    print.set(this)
    this.marker_red = require('../../assets/icon/CR.png')
    this.marker_orange = require('../../assets/icon/CO.png')
    this.marker_green = require('../../assets/icon/CG.png')
    this.marker_red_d = require('../../assets/icon/DR.png')
    this.marker_orange_d = require('../../assets/icon/DO.png')
    this.marker_green_d = require('../../assets/icon/DG.png')
    this.marker_offline = require('../../assets/icon/DB.png')
    this.marker_alarm = require('../../assets/icon/alarm.gif')
    this.marker_offline_alarm = require('../../assets/icon/ADG.gif')
    this.marker_green_alarm = require('../../assets/icon/ACG.gif')
    this.marker_red_alarm = require('../../assets/icon/ADB.gif')
    this.marker_orange_alarm = require('../../assets/icon/ACO.gif')
    this.marker_d_active = require('../../assets/icon/D_Active.png')
    this.marker_d_offline = require('../../assets/icon/D_Offline.png')
    // console.log('mounted ok.')
  },
  beforeDestroy() {
    if (this.timer_refresh_all) {
      clearInterval(this.timer_refresh_all)
      print.info('定时刷新timer_refresh_all已清除', true)
    }
    if (this.timer_refresh_current) {
      clearInterval(this.timer_refresh_current)

      setTimeout(() => {
        print.info('定时刷新timer_refresh_current已清除', true)
      }, 500)
    }
    if (this.timer_refresh_logs) {
      clearInterval(this.timer_refresh_logs)
    }
    if (this.timer_refresh_alarms) {
      clearInterval(this.timer_refresh_alarms)
    }
  },
  components: {
    AsideTab,
    AsideList,
    mapToolConfig,
    tree,
    Charts,
    Alarm
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/mixin.scss";
  .i-body {
    height: calc(100vh - 60px);
    flex-grow: 1;
    .i-side {
      border-right: 1px solid #DCDFE6;
      .i-side-pane {
        background-color: #FFF;
        overflow: auto;
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        width: 100%;
      }
      .i-aside-pane {
        box-sizing: border-box;
        height: 100%;
        overflow: auto;
        border: 1px solid #DCDFE6;
        border-top: none;
        //border-radius: 4px;
      }
      .typeline {
        // 状态类型
        justify-content: space-around;
        & > div {
          font-size: 12px;
          font-weight: 500;
          margin-top: 8px;
          margin-bottom: 8px;
          cursor: pointer;
          &:hover,&.active {
            text-decoration: underline;
          }
        }
      }
    }
    .i-main {
      padding: 0;
      height: auto;
      .i-pane-wrapper{
        overflow: hidden;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
      }
      .i-pane {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        overflow: hidden;
        &.chart {
          overflow-y: auto;
          background-color: #FAFAFA;
          @include scroll-bar;
        }
      }
      .i-pane-map {
        overflow: hidden;
      }
      .i-pane-alarm {
        top: auto;
        left: 20px;
        bottom: 0;
        z-index: 100;
        width: calc(100% - 40px);
        max-height: 300px;
        background-color: #fff;
        border-top: 1px solid #DCDFE6;
        overflow: visible;
        transition: all 0.3s ease;
        &-btn {
          border: 1px solid #DCDFE6;
          background-color: #fff;
          position: absolute;
          left: 50%;
          transform: translateY(-100%) translateX(-50%);
          text-align: center;
          line-height: 30px;
          height: 30px;
          cursor: pointer;
          z-index: 100;
          width: 80px;
        }
      }
    }
    .i-footer {
      //background-color: #B3C0D1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/home/home-改高德.vue